/**
 * @name ShopGoals
 * @description Function for the shop goals service
 * @param {service} $http Angular $http service
 * @param {constant} ENDPOINT The ENDPOINT constant
 * @param {service} Session The Session service
 * @param {library} moment The moment library
 * @param {service} AlertMessages The AlertMessages service
 * @return {function} Returns the shop goals service
 */
function ShopGoals(
  $http,
  ENDPOINT,
  Session,
  moment,
  AlertMessages
) {
  ShopGoals.get = get;
  ShopGoals.create = create;
  ShopGoals.update = update;

  /**
   * @name get
   * @description Function to get a shop goal
   * @return {object} Returns the shop goal
   */
  function get() {
    let id = Session.activeState.association.id;
    if (id) {
      return $http.get(ENDPOINT.server +
      'shops/api/v1.1/shop-goals/?association_id=' + id)
      .then(function(response) {
        return parseGoals(response.data);
      }, function(error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
      });
    }
  }

  /**
   * @name create
   * @description Function to create a goal
   * @param {object} goal The goal to create
   * @return {object} Returns the new goal
   */
  function create(goal) {
    goal.association_id = Session.activeState.association.id;
    return $http.post(ENDPOINT.server + 'shops/api/v1.1/shop-goals/', goal)
    .then(function(response) {
      AlertMessages.add({
        msg: 'Your shop goal has been saved.',
        type: 'success'
      });
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name update
   * @description Function to update a shop goal
   * @param {object} goal The goal to update
   * @return {object} Returns the udpated goal object
   */
  function update(goal) {
    goal.association_id = Session.activeState.association.id;
    return $http.put(ENDPOINT.server + 'shops/api/v1.1/shop-goals/' +
    goal.id + '/', goal)
    .then(function(response) {
      AlertMessages.add({
        msg: 'Your shop goal has been saved.',
        type: 'success'
      });
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name parseGoals
   * @param {unknown} goals The goals to parse
   * @return {array} Returns the array of parsed goals
   */
  function parseGoals(goals) {
    for (let i = 0; i < goals.length; i++) {
      let goal = goals[i];
      goal.start = moment(goal.start_datetime);
      if (goal.end_datetime) {
        goal.end = moment(goal.end_datetime);
      }
    }
    return goals;
  }
  return ShopGoals;
}

angular
  .module('inkfinder')
  .factory('ShopGoals', ShopGoals);



// WEBPACK FOOTER //
// ./components/shop/goals/shop-goals.service.js